import {Routes} from '@angular/router'
import kalpRoutes from './2-kalp/kalp-routes'
import resultRoutes from './3-result/result-routes'
import {KALP_ROUTE_PATH, LOGIN_ROUTE_PATH, RESULT_ROUTE_PATH, START_ROUTE_PATH} from './application/data-types'
import {adminAuthGuard, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'

export const routes: Routes = [
  {
    path: LOGIN_ROUTE_PATH,
    component: LoginComponent
  },
  {
    path: KALP_ROUTE_PATH,
    children: kalpRoutes,
    canActivate: [adminAuthGuard]
  },
  {
    path: START_ROUTE_PATH,
    loadComponent: () => import('./1-start/start/start.component').then(m => m.StartComponent),
    canActivate: [adminAuthGuard]
  },
  {
    path: RESULT_ROUTE_PATH,
    children: resultRoutes,
    canActivate: [adminAuthGuard]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_ROUTE_PATH
  },
  {
    path: '**',
    redirectTo: LOGIN_ROUTE_PATH
  }
]